import { Card, InputGroup, Menu, MenuItem, Popover } from '@blueprintjs/core';
import * as React from 'react';
import { Helmet } from 'react-helmet';
import PlacesAutocomplete, {
  geocodeByPlaceId,
} from 'react-places-autocomplete';

interface MatchedSubstring {
  length: number;
  offset: number;
}

interface Term {
  offset: number;
  value: string;
}

interface Suggestion {
  active: boolean;
  description: string;
  formattedSuggestion: {
    mainText: string;
    secondaryText: string;
  };
  id: string;
  index: number;
  matchedSubstrings: MatchedSubstring[];
  placeId: string;
  terms: Term[];
  types: string[];
}

interface HTMLGeneratorState {
  address: string;
}

class HTMLGenerator extends React.Component<{}, HTMLGeneratorState> {
  public state = {
    address: '',
  };

  private key = 'AIzaSyCwuJZct-5TtFMZmj1XyliEMCStAEcThw8';

  public render() {
    const { address } = this.state;

    return (
      <div>
        <Helmet>
          <script
            type="text/javascript"
            src={`https://maps.googleapis.com/maps/api/js?key=${
              this.key
            }&libraries=places`}
          />
        </Helmet>
        <Card>
          {(window as any).google && (
            <PlacesAutocomplete
              inputProps={{ value: address }}
              onChange={this.handleChange}
              onSelect={this.handleSelect}
              shouldFetchSuggestions={address.length > 2}
              value={address}>
              {({
                getInputProps,
                suggestions,
                getSuggestionItemProps,
                loading,
              }: {
                getInputProps: any;
                suggestions: Suggestion[];
                getSuggestionItemProps: any;
                loading: boolean;
              }) => (
                <div>
                  <Popover
                    minimal={true}
                    isOpen={suggestions.length > 0}
                    className="autocomplete-dropdown-container"
                    content={
                      <Menu>
                        {loading && <MenuItem text="Loading..." />}
                        {suggestions.map((suggestion, index) => (
                          <MenuItem
                            key={index}
                            text={suggestion.description}
                            {...getSuggestionItemProps(suggestion)}
                          />
                        ))}
                      </Menu>
                    }>
                    <InputGroup
                      {...getInputProps({
                        className: 'location-search-input',
                        placeholder: 'Search Places ...',
                      })}
                    />
                  </Popover>
                </div>
              )}
            </PlacesAutocomplete>
          )}
        </Card>
        <Card>
          <p className="contact-title">Midway U Pull Muncie</p>
          <p className="contact-location">6345 Kansas Ave.</p>
          <p className="contact-location">Kansas City, KS 66111</p>
          <a className="contact-link" href="tel:+19132876185">
            📞(913) 287-6185
          </a>
          <a className="contact-link" href="https://goo.gl/maps/5dS2PXDRfcE2">
            🚗Directions
          </a>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12387.358608160943!2d-94.726307!3d39.08735!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x78a0598eb09fa8a9!2sMidway+U+Pull+-+Muncie!5e0!3m2!1sen!2sus!4v1538348681266"
            width="200"
            height="200"
            style={{ border: 0 }}
          />
        </Card>
      </div>
    );
  }

  private getSuggestion = async (placeId: string) => {
    const suggestion = await geocodeByPlaceId(placeId);

    console.log(suggestion);
  };

  private handleChange = (address: string) => {
    console.dir(address);
    this.setState({ address });
  };

  private handleSelect = (address: string, placeId: string) => {
    console.dir(address, placeId);

    this.getSuggestion(placeId);
  };
}

export default HTMLGenerator;



// WEBPACK FOOTER //
// ./src/views/HTMLGenerator.tsx